import React from 'react';
import Lottie from 'lottie-react';

import lottieLoader from 'assets/icons/SFI_Logo_Loader_Lottie.json';

const SfiLoader = () => (
	<div>
		<Lottie
			animationData={lottieLoader}
			loop={true}
			style={{
				height: 168,
				width: 242,
				maxWidth: '100%',
				maxHeight: '25vh',
				flexShrink: 1,
			}}
		/>
	</div>
);

export default SfiLoader;
